// Componet for Badges of AddonGroup
// Author : Huen Oh (heons921@gmail.com)
// @param {string}   cyPrefix Prefix for data-cy.
// @param {string[]} data     List of strings for the badges.
// @param {string}   variant  Type of the badge. It changes the color.

<template>
  <div>
    <!-- AddonGroup -->
    <BaseBadge
      v-for="(group,index) in data" :key="group.value"
      :cyPrefix="`${cyPrefix}-badge-addon-group-${index}`"
      :data="getNameByIdFromList(group, selectableAddonGroups)"
      :variant="variant"
      @onDelete="onDelete(index)"
    />
  </div>  
</template>


<script>
/**
 * Event on click of delete bagde.
 * 
 * @event BadgeListAddonGroup#onDelete
 * @type {object}
 * @param {number} index Index.
 */

import { getNameByIdFromList } from "@/utils/general.js"
import BaseBadge from '@/components/Common/BaseBadge'
import { mapGetters } from 'vuex'

export default {
  components:{
    BaseBadge,
  },
  computed:{
    ...mapGetters("addon_group",    ["selectableAddonGroups"]),
 },
  props:{
    // {string} Prefix for data-cy.
    cyPrefix: {
      type: String,
      default: ""
    },
    // {string[]} List of strings for the badges.
    data:{
      type:Array,
      default: () => []
    },
    // {string} Type of the badge. It changes the color.
    variant:{
      type:String,
      default: "primary"
    },
  },
  methods:{
    // Get name of an item from a list
    getNameByIdFromList,

    onDelete(index){
      // Event - BadgeListAddonGroup#onDelete
      this.$emit('onDelete',index)
    }
  }
}
</script>
